import React from "react";
import Navbar from "../../components/navbar/Navbar";
import "./Home.css";
import Stock from "../stock/Stock";
import Qr from "../../images/qr.png";

function Home() {
  return (
    <div className="home-container">
      <Navbar />

      <section id="home" className="section home-section">
        <div className="hero-content">
          <h1 className="hero-title">Bienvenido a La Cochera Auto Parts</h1>
          <p className="hero-subtitle">Tu mejor opción en autopartes de calidad.</p>
          <a href="#services" className="hero-button">Ver Stock</a>
        </div>
      </section>

      <section id="about" className="section about-section">
  <h2 className="section-title">Venta Por Mercado Libre</h2>
  <p className="section-text">
    Ofrecemos autopartes de la mejor calidad para tu vehículo. Realizamos envíos a toda la República a través de Mercado Libre, garantizando seguridad y confianza en tu compra.
  </p>
</section>



      {/* Services / Stock Section */}
      <section id="services" className="section services-section">
        <h2 className="section-title">Nuestro Stock</h2>
        <Stock />
      </section>

      {/* Contact Section */}
      <section id="contact" className="section contact-section">
        <h2 className="section-title">Contacto</h2>
        <p className="section-text">¡Llámanos o visítanos para encontrar la pieza que necesitas!</p>
        <p>También puedes escribirnos por WhatsApp escaneando el siguiente código QR:</p>
        <img src={Qr} alt="QR de WhatsApp" className="qr-image" />
      </section>
    </div>
  );
}

export default Home;
